import {
  GET_SCANNED_MASK,
  GET_SCANNED_MASK_SUCCESS,
  GET_SCANNED_MASK_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getScannedMaskReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SCANNED_MASK:
      return { ...state, loading: true };
    case GET_SCANNED_MASK_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_SCANNED_MASK_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getScannedMaskReducer;
